import React from 'react';
import { SelectAccount } from './SelectAccount';
import { SelectInventory } from './SelectInventory';

// المكون الرئيسي الذي يعيد حقول الإدخال بناءً على نوع الحقل
export const DynamicInput = ({ param, onChange }) => {
  const { type, lable, lable2, value } = param;

 

  switch (type) {
    case 'Inventory':
      return <SelectInventory label={lable} label2={lable2} value={value} onChange={onChange} />;
    case 'Account':
      return <SelectAccount label={lable} label2={lable2} value={value} onChange={onChange} />;
    default:
      return null;
  }
};
